import React, { useEffect } from 'react';

function Faith() {
  useEffect(() => {
    document.title = 'John Chen | Faith'
  }, [])

  return <>
    <h3>This page is still in development.</h3>
    <p>I'll still love to get in touch if you have any thoughts/questions!
      <br/><br/>
      Find my contact details at 
      <a href='https://seevee.co.nz/john' target="_blank"  rel="noreferrer"> https://seevee.co.nz/john</a>
    </p>
  </>;
}

export default Faith;
